import axios from 'axios'
import type { JobCriteriaForm } from '../../../schema/job'
import { getApiUrl, PERFORMANCE_BASED_JOB_API_URL } from '../../util/api/api'

const submitJobCriteria = ({ data, jobId }: { data: JobCriteriaForm; jobId: string }) =>
  axios.post<void>(getApiUrl(`${PERFORMANCE_BASED_JOB_API_URL}/criteria/${jobId}`), data, {
    withCredentials: true,
  })

export default submitJobCriteria
